import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dataprotect',
  templateUrl: './dataprotect.component.html',
  styleUrls: ['./dataprotect.component.scss']
})
export class DataprotectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
